import React from 'react';
import { RecruiterLoadingScreen } from './RecruiterLoadingScreen';
import { RecruiterInlineEmpty } from './RecruiterInlineEmpty';

interface LoadingStateProps {
  label?: string;
  fullHeight?: boolean;
  icon?: React.ComponentType<{ className?: string }>;
}

/**
 * @deprecated Prefer RecruiterLoadingScreen for full-page loads.
 * Kept for incremental migration — delegates to the new loader when an icon is set.
 */
export const RecruiterLoadingState: React.FC<LoadingStateProps> = ({ label, fullHeight, icon }) => {
  if (icon && fullHeight) {
    return <RecruiterLoadingScreen icon={icon} />;
  }

  return (
    <div
      className={`flex flex-col items-center justify-center ${fullHeight ? 'min-h-[50vh]' : 'py-24'}`}
    >
      <div className="w-6 h-6 rounded-full border-2 border-slate-200 border-t-pink-500 animate-spin mb-3" />
      {label && <p className="text-sm font-medium text-slate-500 tracking-wide">{label}</p>}
    </div>
  );
};

interface EmptyStateProps {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  description?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

/** @deprecated Prefer RecruiterInlineEmpty — wraps the RCC card empty pattern. */
export const RecruiterEmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
  className,
}) => (
  <RecruiterInlineEmpty
    icon={icon}
    title={title}
    description={description}
    action={action}
    className={className}
  />
);

export { RecruiterLoadingScreen } from './RecruiterLoadingScreen';
export { RecruiterPageShell } from './RecruiterPageShell';
export { RecruiterGateCard } from './RecruiterGateCard';
export { RecruiterInlineEmpty } from './RecruiterInlineEmpty';
